/* eslint-disable no-console */

/* eslint-disable indent */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-mixed-spaces-and-tabs *
/* eslint-disable no-console */
import React, { Component } from 'react';
import Filters from '../Filters';
import Modal from 'react-modal';
import {
	mainUrl,
} from '../../Constants';
import formatDate from 'dateformat';
import KendoScheduler from '../../Utilities/KendoScheduler';
import { customEditTemplate } from '../../Utilities/KendoScheduler/customEditTemplate';
import { inviteesListTemplate, inviteesEditTemplate } from '../../Utilities/KendoScheduler/inviteesModal';
import $ from 'jquery';
import kendo from '@progress/kendo-ui';
import diff from 'deep-diff';
import { assets } from '../../Store/Reducers/EntityReducer';
import Schedule from '../ScheduleBlock/index';
import { scheduleError } from '../../Store/Actions/SchedulerActions';
import { formatDateYYYYMMDD } from '../../Store/Actions/RestActions';
import SchedulePage from '../../Pages/SchedulePage/SchedulePage';
const Spinner = require('react-spinkit');

const conflictList = [];
var isFilterClicked = 0;

export default class SchedulePageComponent extends Component {
    
	constructor(props) {
	super(props);
	   this.toggleModal = this.toggleModal.bind(this);
	   this.setView = this.setView.bind(this);
	//	this.checkIfDiffView = this.checkIfDiffView.bind(this);
		let currDate = new Date();
		let conflictMsg = '';		
				
		currDate.setHours(0, 0, 0, 0);
		this.state = {
			 showModal: false, currentDate: currDate, endDate: currDate, currentView: [
				{ type: 'day', selected: true },
				'week',
				'month',
			]
		};

	}

	toggleModal(showModal, msg) {
		this.setState({ showModal, msg });
	}
   

	setView(view) {
		let opts = [
			'day',
			'week',
			'month',
		];

		opts[opts.findIndex(id => id === view)] = { type: view, selected: true };
		this.setState({ currentView: opts });
	}
	//checkIfDiffView(e) {
	//	return e.action === "rebind" && this.state.currentDate.getTime() !== e.sender.view().startDate().getTime() && this.state.endDate.getTime() !== e.sender.view().endDate().getTime();

//	}
	
	render() {
		return (
			< div >
   			      <Filters
 					searchOnChange={this.props.searchOnChange}
					searchable={[this.props.rooms]}
					multiSelectBoxes={[
						{
							
							label: 'Room Type',
							filterClass: 'roomTypeGroup',
							items: this.props.roomTypes,
							onChange: this.props.handleRoomTypeFilter,
							
						},
						// {
						//     label: "Resource Type",
						//     filterClass: "resourcesTypeGroup",
						//     items: this.props.assets,
						//     onChange: this.props.handleResourceFilter
						// }
					]}
					Dropdowns={[
						{
							
							label: "Location/Building",
							filterClass: "buildingSelect",
							items: this.props.buildings,
							onChange: this.props.handleBuildingFilter,
							defaultValue: this.props.buildingFilter,
						},
						{
							label: "Floor",
							filterClass: "floorSelect",
							items: this.props.floors,
							onChange: this.props.handleFloorFilter,
							defaultValue: this.props.floorFilter,
						},
						{
							label: 'Room',
							filterClass: 'roomSelect',
							items: this.props.rooms,
							onChange: this.props.handleRoomFilter, 
							defaultValue: this.props.roomFilter,
						},
					]}

					// we do not want to show the checkbox on the schedule page but 
					// need to keep the reference to prevent mapping errors
					RoomDisplayToggle={[
						//{
						//onChange: this.props.handleShowInactiveRoomsFilter,
						//filterClass: 'roomTypeGroup',
						//label: 'Show Inactive',
						//defaultValue: this.props.roomFilter,
						//},
					]}
				/>

				{!this.props.eventLoading ?
					this.props.filteredData.length === 0 ?
						<div id="loading-spinner-cont">
							<div id="loading-spinner"><h1>No Rooms Selected</h1></div>
						</div>
						:
						<KendoScheduler options={
							{
								
								footer: {
									command: false,
								},
								date:  this.state.currentDate,
								
								// min: new Date(Date.now()), changed to one month in the past below
								min: new Date(
									new Date().getFullYear(),
									new Date().getMonth() - 1,
									new Date().getDate()),
															
								height: 600,
								views: this.state.currentView,
								dataBinding: (e) => {
								

								// ARS-499	
								// monitors the filter controls for clicks.  If either control is 
								// clicked, we reset the schedule/calender to the curent date
								const roomDropdown  = document.getElementsByClassName('roomSelect') [0];
								const floorDropdown  = document.getElementsByClassName('floorSelect') [0];
								const buildingDropdown  = document.getElementsByClassName('buildingSelect') [0];
								const optionBox  = document.getElementsByClassName('optionBox') [0];
								roomDropdown.addEventListener('click', function(){ isFilterClicked = 1;});
								floorDropdown.addEventListener('click', function(){ isFilterClicked = 1;});
								buildingDropdown.addEventListener('click', function(){ isFilterClicked = 1;});
								optionBox.addEventListener('click', function(){ isFilterClicked = 1;});
								
								if(isFilterClicked == 1){
									this.setState({ currentDate: formatDateYYYYMMDD(new Date()),  });
									isFilterClicked = 0;
								}
								// end of ARS-499 update
														

								let avgColumnSize = 350;
								if (e.sender._selectedViewName === "week" || e.sender._selectedViewName === "month") {
									avgColumnSize = 450;
								}
								if (avgColumnSize * this.props.filteredData.length < $('.k-scheduler-header-wrap').width()) {
									avgColumnSize = ($('.k-scheduler-header-wrap').width() - 20) / this.props.filteredData.length;
								}
								$('.k-scheduler-content .k-scheduler-table,	.k-scheduler-header .k-scheduler-table').width(avgColumnSize * this.props.filteredData.length);

								// check that we're on a different day
								//if (this.checkIfDiffView(e)) {
															
									// <<<--------  This gets called once as nav to diff view or date range.
									// this.props.scheduleFetch(e.sender.view().endDate());
									// if (e.sender._selectedViewName === "month") { // Month view doesn't have a start date so this borks it
									// 	let monthDate = new Date(e.sender.view().startDate().getTime());
									// 	monthDate.setMonth(monthDate.getMonth() + 1);
									// 	this.setState({ currentDate: monthDate, endDate: new Date(e.sender.view().endDate().getTime()) });
									// } else {
									// 	this.setState({ currentDate: e.sender.view().startDate(), endDate: new Date(e.sender.view().endDate().getTime()) });
									// }
							
								//}
							},

							// JJ - ARS-505, IMPORTANT:This must go before all other properties
							// adding this cancel property to refresh the scheduler when the user clicks cancel 
							// otherwise, when a BadRequest is sent back from the API, the 
							// spinner will remove focus from the scheduler and spin indefinitley
							cancel: () => {
								$('#kendo-scheduler').data('kendoScheduler').refresh();
							},
								navigate: (e) => {
									 
									if (e.action === "changeView") {
																		
									// ARS-499				
									 if(e.view === 'day'){
									   this.setState({ currentDate: formatDateYYYYMMDD(new Date(e.date)),  });
									 }
									 // end of ARS-499 update
																
									//check for view type
										if (e.view === "week" || e.view === "month" || e.view === 'timeline') {
											if (this.props.filteredData.length > 11) {
												e.preventDefault();
												conflictList.splice(0, conflictList.length);
												this.conflictMsg = "Please use the filters to narrow down the rooms selection to 3 or less to display this view.";
												this.toggleModal(true, this.conflictMsg);
											} else {
												this.setView(e.view); // Update state with new view selection
											}
										} else {
											this.setView(e.view);
										}
									}
								},
								// timezone: "Etc/UTC",
								editable: {
									confirmation: true,
									template: kendo.template(customEditTemplate)({ isAdmin: this.props.isAdmin || this.props.isEventCreator }),
									// editTemplate: inviteesEditTemplate
								},
								edit: (e) => {
									
									const roomId = e.container.find('#roomId').data('kendoDropDownList');
									roomId.dataSource.data(e.sender.resources[0].dataSource.data());
									if (e.event.roomId !== null) {
										roomId.select(roomSelect => roomSelect.value === e.event.roomId);
									}
									// Reservation Type Set
									const reservationTypeId = e.container.find('#reservationTypeId').data('kendoDropDownList');
									reservationTypeId.dataSource.data(e.sender.resources[1].dataSource.data());
									if (e.event.reservationTypeId !== 0) {
										reservationTypeId.select(reservSelect => reservSelect.value === e.event.reservationTypeId);
									} else if (e.sender.resources[1].dataSource.data().length > 0) {
										reservationTypeId.select(0);
										e.event.reservationTypeId = e.sender.resources[1].dataSource.data()[0].value;
									}


									const assetId = e.container.find('#assetIds').data('kendoMultiSelect');
									assetId.dataSource.data(e.sender.resources[2].dataSource.data());
									if (e.event.assets) {
										assetId.value(e.event.assets.map(o => ({ text: o.name, value: o.id })));
									}

									const ownerId = e.container.find('#ownerId').data('kendoDropDownList');
									ownerId.dataSource.data(e.sender.resources[3].dataSource.data());
									if (e.event.ownerId !== "") {
										ownerId.select(ownerSelect => ownerSelect.value === e.event.ownerId);
									} else if (e.sender.resources[3].dataSource.data().length > 0) {
										ownerId.select(ownerSelect => ownerSelect.value === this.props.userId);
										e.event.ownerId = this.props.userId;
									}

									//ARS-508 Recurring Reservation Rule - For New Events - Don't allow specific user groups to create recurring reservations.
									const userId = localStorage.getItem('userId');									
									var recurRule = $('[data-role=recurrenceeditor]').data('kendoRecurrenceEditor');
									if (recurRule != undefined) {

										//if the current user belongs to the following groups remove recurrence options
										var hideDropdownForGroups = ['BLOOMBERG TRAINING LAPTOPS ONLY', 'GRADUATE STUDENTS', 'MARKETPLACE STUDENTS', 'TORCH FUNDS', 'TVA FUNDS', 'UNDERGRADUATE STUDENTS'];
										this.props.users.reduce(function (id, obj) {
											if (obj.id === userId) {
												console.log(obj.userGroupName);
												if (hideDropdownForGroups.includes(obj.userGroupName.toUpperCase())) {
													console.log(`Hiding dropdown for user: ${obj.id}`);

													//Hide dropdown and label.
													recurRule.wrapper[0].hidden = true;
													recurRule._container[0].nextSibling.parentElement.childNodes[17].style.display = 'none';
												}
											}
										});
									}

									// FOR EXISTING EVENTS - remove the NEVER option
									if (e.event.id !==0) {
										var recurEditorExisting = $('[data-role=recurrenceeditor]').data('kendoRecurrenceEditor');
										if (recurEditorExisting != undefined) {
											recurEditorExisting.setOptions({
											change: function (e) {
												// remove the Never option
												if(e.sender._buttonNever[0] !== undefined )
												   if(e.sender._buttonNever[0].labels[0] !== undefined )
														 e.sender._buttonNever[0].labels[0].innerText = "";
											   }
											});
										}
									}
									// FOR NEW EVENTS - remove the NEVER option
									if (e.event.id === 0) {
										var recurEditor = $('[data-role=recurrenceeditor]').data('kendoRecurrenceEditor');
										if (recurEditor != undefined) {
											recurEditor.setOptions({
											change: function (e) {
												$('.asWrapper').removeClass('hidden');
											
												// remove the Never option
												if(e.sender._buttonNever[0] !== undefined )
												   if(e.sender._buttonNever[0].labels[0] !== undefined )
														 e.sender._buttonNever[0].labels[0].innerText = "";
											   }
											});
										}
									} else {
										// this is updating an event 
										//may need to show the autoSchedule checkbox eventually 
									}

							
																											
									// Invitiees Set and listener setup
									const inviteesBox = e.container.find('#inviteesBox')
										.kendoListView({
											// template: inviteesListTemplate
											dataSource: e.event.invitees,
											// selectable: true,
											navigatable: true,
											editable: true,
											template: inviteesListTemplate,
											editTemplate: inviteesEditTemplate,
										})
										.data('kendoListView');
									$(".k-add-button").click(() => {
										inviteesBox.add();
									});

								},
								remove: (e) => {
									// CHECK IF PERSON IS THE SAME OWNER OF THE EVENT
									// And NOT AN ADMIN
									//handled on the backend
									// if (e.event.ownerId !== this.props.userId && !this.props.isAdmin) {
									// 	alert('You do not have access to edit this event.');
									// 	e.preventDefault();
									// }
								},
								save: (e) => {

									// CHECK IF PERSON IS THE SAME OWNER OF THE EVENT
									// And NOT AN ADMIN
									//handled on the backend
									// removed at request of Gregg 6/11
									/*if (e.event.ownerId !== this.props.userId && !this.props.isAdmin && e.event.id !== 0) {
										alert('You do not have access to edit this event.');
										e.preventDefault();

									}*/


									const scheduler = $('#kendo-scheduler').data('kendoScheduler');
									const events = scheduler.occurrencesInRange(e.event.start, e.event.end);
									// filter based on roomId
									const filteredEvents = events.filter(event => event.roomId === e.event.roomId);
									if (filteredEvents.length > 1) // new event is included, that's why > 1
									{
										alert('Room is already booked at the requested time.');
										e.preventDefault();
									}

									// GET INVITEES FROM INVITEEBOX;
									if (e.container) {
										const invitees = e.container.find('#inviteesBox').data('kendoListView').dataSource.data();
										e.event.invitees = invitees;
										e.event.ScheduledEventInvitees = invitees;
										e.event.dirty = true
									}
								},

								dataSource: {
									batch: true,
									editable: true,
									// data: this.props.events,
									error: function (e) {
										if (e.errorThrown) {
											alert(e.errorThrown);

										}
										this.cancelChanges();

									},
									transport: {
										read: (options) => {
											// Just use events from props
											options.success(this.props.events);
										},
										update: (options) => {
											const data = Object.assign({}, options.data.models[0]);
											if (data.accountId === null) {
												data.accountId = parseInt(this.props.accountId.substring(this.props.accountId.length - 1), 10);
											}
											 $('.k-scheduler-update').html('<span class="saving">Saving</span>');

											$.ajax({
												url: `${mainUrl}accounts/${this.props.accountId}/rooms/${options.data.models[0].roomId}/scheduledEvents/${data.id}`,
												dataType: 'json',
												contentType: 'application/json; charset=utf-8',
												type: 'PUT',
												data: kendo.stringify(data),
												success: (result) => {
													options.success(result);
													this.props.eventUpdated(options.data.models[0]);
												},

												error: (result) => {
													$('.k-scheduler-update').html('<span>Save</span>');
													if(result.responseJSON !==undefined){
														if (result.responseJSON.roomAvailableConflicts) {
														var conflicts = result.responseJSON.roomAvailableConflicts;
														var errorMsg = '';
														this.conflictMsg = "Your reservation " + options.data.models[0].title + " " + formatDate(options.data.models[0].start, 'mm/dd/yy hh:MM TT') + 
															" until " + formatDate(options.data.models[0].end, 'mm/dd/yy hh:MM TT') + 
															" conflicts with the following reservations.\n\n";
														 conflictList.splice(0, conflictList.length);
													  	 conflicts.forEach(element => {
														    	errorMsg = errorMsg +   element.conflictTitle + ', ' + formatDate(element.conflictStart, 'mm/dd/yy hh:MM TT') + ' until ' + formatDate(element.conflictEnd, 'mm/dd/yy hh:MM TT') + "\n";
														        conflictList.push(errorMsg);
															});
															alert(this.conflictMsg+errorMsg);
														   
													    
													} else {
														alert(result.responseText);
													}
												}
												else{
													alert(result.responseText);
												}
												},

												headers: {
													Authorization: `Bearer ${localStorage.getItem('id_token')}`,
													'Content-Type': 'application/json',
												}
											});


										},
										create: (options) => {

											// Only set if not set by admin
											if (options.data.models[0].ownerId === "") {
												options.data.models[0].ownerId = this.props.userId;
											}
											if (options.data.models[0].accountId === 0) {
												options.data.models[0].accountId = parseInt(this.props.accountId);
											}
											// getting the buiding id associated with the event and room
											var tempId = options.data.models[0].roomId;
											var bid = this.props.filteredData.find((item) => tempId === item.id);
											options.data.models[0].buildingId = bid.buildingId;
																							
											$('.k-scheduler-update').html('<span class="saving">Saving</span>');
											$.ajax({
												url: `${mainUrl}accounts/${this.props.accountId}/rooms/${options.data.models[0].roomId}/scheduledEvents`,
												dataType: 'json',
												contentType: 'application/json; charset=utf-8',
												type: 'POST',
												data: kendo.stringify(options.data.models[0]),
												
												success: (result) => {
													var conflicts = result.conflicts;
													JSON.stringify(conflicts);
													if (conflicts.length > 0) {
														var errorMsg = '';
														this.conflictMsg = "Your reservation " + options.data.models[0].title + " " + formatDate(options.data.models[0].start, 'mm/dd/yy hh:MM TT') +
															" until " + formatDate(options.data.models[0].end, 'mm/dd/yy hh:MM TT') +
															" conflicts with the following reservations.\n\n";
														conflictList.splice(0, conflictList.length);
														conflicts.forEach(element => {
															errorMsg = errorMsg + element.conflictTitle + ', ' + formatDate(element.conflictStart, 'mm/dd/yy hh:MM TT') + ' until ' + formatDate(element.conflictEnd, 'mm/dd/yy hh:MM TT') + "\n";
															conflictList.push(errorMsg);
														});
														alert(this.conflictMsg+errorMsg);
													}
													options.success(result);
													this.props.eventSaved(result);
												},

												error: (result) => {
													var errorMsg = '';
													// options.error(result);
													$('.k-scheduler-update').html('<span>Save</span>');
													
													if (result.responseJSON !== undefined) {
														if (result.responseJSON.roomAvailableConflicts) {
															var conflicts = result.responseJSON.roomAvailableConflicts;
															this.conflictMsg = "Your reservation " + options.data.models[0].title + " " + formatDate(options.data.models[0].start, 'mm/dd/yy hh:MM TT') +
																" until " + formatDate(options.data.models[0].end, 'mm/dd/yy hh:MM TT') +
																" conflicts with the following reservations.\n\n";
															conflictList.splice(0, conflictList.length);
															conflicts.forEach(element => {
																errorMsg = errorMsg + element.conflictTitle + ', ' + formatDate(element.conflictStart, 'mm/dd/yy hh:MM TT') + ' until ' + formatDate(element.conflictEnd, 'mm/dd/yy hh:MM TT') + "\n";
																conflictList.push(errorMsg);
															});
															alert(this.conflictMsg+errorMsg);
													} else {
															alert(result.responseText);
														}
												}
												else{
													alert(result.responseText);
												  }
												},

												headers: {
													Authorization: `Bearer ${localStorage.getItem('id_token')}`,
													'Content-Type': 'application/json',
												}
											});
										},
										
										destroy: (options) => {
											$.ajax({

												url: `${mainUrl}accounts/${this.props.accountId}/rooms/${options.data.models[0].roomId}/scheduledEvents/${options.data.models[0].id}`,
												dataType: 'json',
												contentType: 'application/json; charset=utf-8',
												type: 'DELETE',
												success: (result) => {
													options.success(result);
													this.props.eventDeleted(options.data.models[0]);
												},
												error: (result) => {
													options.error(result, result.status, result.responseText);


												},
												headers: {
													Authorization: `Bearer ${localStorage.getItem('id_token')}`,
													'Content-Type': 'application/json',
												}
											});
										},
										parameterMap: (options, operation) => {
											if (operation !== 'read' && options.models[0]) {
												return kendo.stringify(options.models[0]);
											}
										},
									},

									schema: {
										model: {
											id: 'id',
											fields: {
												id: { from: 'id', type: 'number' },
												title: { from: 'title', defaultValue: 'No title', validation: { required: true } },
												start: { type: 'date', from: 'start' },
												end: { type: 'date', from: 'end' },
												
												// startTimezone: {from: "startTimezone", defaultValue: "Etc/GMT" },
												// endTimezone: {from: "endTimezone", defaultValue: "Etc/GMT" },
												description: { from: 'description' },
												recurrenceId: { from: 'recurrenceId' },
												recurrenceRule: { from: 'recurrenceRule' },
												recurrenceException: { from: 'recurrenceException' },
												autoSchedule: { type: 'boolean', from: 'autoSchedule' },
												roomId: { from: 'roomId', nullable: true },
												isAllDay: { type: 'boolean', from: 'isAllDay' },
												buildingId: { from: 'buildingId', nullable: true },
												// floorId: {from: 'floorId', type: 'number', defaultValue: '' },
												accountId: { from: 'accountId', type: 'number' },
												reservationTypeId: {
													from: 'reservationTypeId',
													type: 'number',
													validation: {
														required: true, name: 'reservationTypeId', title: 'Please select a reservation type',
													},
												},
												ownerId: { from: 'ownerId', type: 'string' },
												assets: { from: 'assets', type: 'array' },
												invitees: { from: 'invitees', editable: true },
											},
										},
									},
								},
								group: {
									resources: ['Rooms'],
								},

								resources: [
									{
										field: 'roomId',
										name: 'Rooms',
										dataSource: this.props.filteredData.map(e => ({ text: e.name, value: e.id })),
										title: 'Room',
										
										
									},
									{
										field: 'reservationTypeId',
										name: 'Reservation Types',
										dataSource: this.props.reservationTypes.map(e => ({ text: e.name, value: e.id })),
										title: 'Reservation Types',
									},
									{
										field: 'assetIds',
										name: 'Assets',
										title: 'Resources',
										multiple: true,
										dataSource: this.props.assets.map(e => ({ text: e.name, value: e.id })),
										// removed the line below to show all resources, including fixed
										//dataSource: this.props.assets.filter(e =>  e.isFixed !== true).map(e => ({ text: e.name, value: e.id })),
									},
									{
										field: 'ownerId',
										name: 'Owner',
										dataSource: this.props.users.sort(sortByName).map(e => ({ text: e.email, value: e.id })),
										title: 'Owner',
										multiple: false,
									},

								],

							}
						}
						/>
					: <div id="loading-spinner-cont">
						<div id="loading-spinner"><h1>Loading...</h1><Spinner name="line-scale-pulse-out-rapid" /></div>
					</div>}
				<Modal
					isOpen={this.state.showModal}
					onRequestClose={() => this.toggleModal(false, null)}
					className='conclictAlerts'
					>
					<button className="closeBtn" onClick={() => this.toggleModal(false, '')}>X</button>
						<div >
							<p><b>{this.conflictMsg}</b></p>
							<br></br>
							<p>
					  			{ 
								  conflictList.map(function(conflicts){
								  return <li>{conflicts}</li>;
								  })
							    }
							</p>
						</div>
				</Modal>
			</div>
		);
	}
}

const sortByName = (a, b) => {
	if (!a.email || !b.email) {
		return 0;
	}
	let nameA = a.email.toUpperCase(); // ignore upper and lowercase
	let nameB = b.email.toUpperCase(); // ignore upper and lowercase
	if (nameA < nameB) {
		return -1;
	}
	if (nameA > nameB) {
		return 1;
	}

	// names must be equal
	return 0;
};



// WEBPACK FOOTER //
// ./src/Components/Pages/SchedulePageComponent.js